import * as types from './types';

function setCityToCityData(cityToCityId, data) {
    return {
        meta: {
            id: cityToCityId,
        },
        payload: data,
        type: types.SET_C2C_DATA,
    };
}

function setSelectedTimeTableDate(cityToCityId, date) {
    return {
        meta: {
            id: cityToCityId,
        },
        payload: date,
        type: types.SET_SELECTED_TIME_TABLE_DATE,
    };
}

export {
    setCityToCityData,
    setSelectedTimeTableDate,
};
